module.exports = __webpack_public_path__ + "static/media/google_play_badge.5e97434e.svg";